<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
        <VRHeader :headerData="this.headerData"
          :analysis="{PercentagesFinancialAnalysis, DollarsFinancialAnalysis, VarianceFinancialAnalysis, VarianceFinancialAnalysisAux, client, checkName}" />
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4">
        <div class="navbar md-toolbar md-transparent market-industy md-elevation-4 p-0">
          <h1 class="section_header">Industry Financial Analysis</h1>
          <div class="md-toolbar-row fundamentals_wpr p-0">
            <div class="md-card-nav-tabs">
              <div class="md-toolbar-row fundamentals_area p-0 m-0">
                <nav-tabs-card no-label md-elevation="0">
                  <template slot="content">
                    <md-tabs md-alignment="left" class="p-0">
                      <md-tab md-label="Percentages" md-icon="percent" class="p-0">
                        <div class="md-layout">
                          <md-card class="m-0">
                            <md-card-header>
                              Percentages<md-icon class="tooltip">priority_high</md-icon>
                              <div class="info_content">
                                <h2>Introduction</h2>
                                <p>
                                  The three tables in this section display selected Profit-Loss and Balance Sheet line
                                  items
                                  which
                                  are applied to the Valuation Business Value analysis. The tables present line items in
                                  dollar values;
                                  as a per cent of total Revenue or Assets; and as percentage of the firm’s variance
                                  from
                                  industry peer group
                                  averages based on your selections:
                                  NAICS {{ this.naics }} {{ this.industryName }}
                                  <br />
                                  Sales Class: {{ this.vestimateReport.IF['sales-class'] }}
                                  <br />In addition to metrics from the traditional financial statement, the tables
                                  display values
                                  for full-time equivalent
                                  employees (for the calculation of Sales per Employee); full-time equivalent Average
                                  Annual
                                  Wage (for the calculation
                                  of the Efficiency Ratio, i.e., Sales per Employee/Average Annual Wage); and Owner
                                  Replacement Compensation and 1x Expense
                                  Addbacks for the accurate calculation of Owner Earnings.
                                </p>
                              </div>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item md-size-100 p-0">
                                  <md-table class="hdlessTable" v-model="PercentagesFinancialAnalysis"
                                    table-header-color="blue">
                                    <md-table-row class="tableHead">
                                      <md-table-head></md-table-head>
                                      <md-table-head colspan="3">INDUSTRY</md-table-head>
                                      <md-table-head colspan="3">{{this.client.client_name?this.client.client_name:'FIRM'}}
                                      </md-table-head>
                                    </md-table-row>
                                    <md-table-row v-for="item in PercentagesFinancialAnalysis" :key="item.id">
                                      <md-table-cell md-label="Parameters">
                                        {{ item.name }}
                                      </md-table-cell>
                                      <md-table-cell :hidden="checkName(item,'industry',key)"
                                        v-for="key in Object.keys(item.industry)" :md-label="key"
                                        :key="'industry_' + key">{{ item.industry[key] }}</md-table-cell>
                                      <md-table-cell :hidden="checkName(item,'firm',key)"
                                        v-for="key in Object.keys(item.firm)" :md-label="key" :key="'firm_' + key">{{
                                        item.firm[key] }}</md-table-cell>
                                    </md-table-row>
                                    <md-table-row></md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                      </md-tab>
                      <md-tab md-label="Dollars" md-icon="payments" class="p-0">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0">
                            <md-card class="m-0">
                              <md-card-header>
                                Dollars <span>( All figures in USD )</span>
                                <md-icon class="tooltip">priority_high</md-icon>
                                <div class="info_content">
                                  <h2>Introduction</h2>
                                  <p>
                                    The three tables in this section display selected Profit-Loss and Balance Sheet line
                                    items
                                    which
                                    are applied to the Valuation Business Value analysis. The tables present line items
                                    in
                                    dollar values;
                                    as a per cent of total Revenue or Assets; and as percentage of the firm’s variance
                                    from
                                    industry peer group
                                    averages based on your selections:
                                    NAICS {{ this.naics }} {{ this.industryName }}
                                    <br />
                                    Sales Class: {{ this.vestimateReport.IF['sales-class'] }}
                                    <br />In addition to metrics from the traditional financial statement, the tables
                                    display values
                                    for full-time equivalent
                                    employees (for the calculation of Sales per Employee); full-time equivalent Average
                                    Annual
                                    Wage (for the calculation
                                    of the Efficiency Ratio, i.e., Sales per Employee/Average Annual Wage); and Owner
                                    Replacement Compensation and 1x Expense
                                    Addbacks for the accurate calculation of Owner Earnings.
                                  </p>
                                </div>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-size-100 p-0">
                                    <md-table v-model="DollarsFinancialAnalysis" table-header-color="blue"
                                      class="hdlessTable">
                                      <md-table-row class="tableHead">
                                        <md-table-head></md-table-head>
                                        <md-table-head colspan="3">INDUSTRY</md-table-head>
                                        <md-table-head colspan="3">{{this.client.client_name?this.client.client_name:'FIRM'}}</md-table-head>
                                      </md-table-row>
                                      <md-table-row v-for="item in DollarsFinancialAnalysis" :key="item.id">
                                        <md-table-cell md-label="Parameters">
                                          {{ item.name }}
                                        </md-table-cell>
                                        <md-table-cell :hidden="checkName(item,'industry',key)"
                                          v-for="key in Object.keys(item.industry)" :key="'industry_' + key"
                                          :md-label="key">{{ item.industry[key] }}</md-table-cell>
                                        <md-table-cell :hidden="checkName(item,'firm',key)"
                                          v-for="key in Object.keys(item.firm)" :key="'firm_' + key" :md-label="key">{{
                                          item.firm[key] }}</md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-tab>
                      <md-tab md-label="Variance" md-icon="money" class="p-0">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0">
                            <md-card class="m-0">
                              <md-card-header>
                                Variance<md-icon class="tooltip">priority_high</md-icon>
                                <div class="info_content">
                                  <h2>Introduction</h2>
                                  <p>
                                    The three tables in this section display selected Profit-Loss and Balance Sheet line
                                    items
                                    which
                                    are applied to the Valuation Business Value analysis. The tables present line items
                                    in
                                    dollar values;
                                    as a per cent of total Revenue or Assets; and as percentage of the firm’s variance
                                    from
                                    industry peer group
                                    averages based on your selections:
                                    NAICS {{ this.naics }} {{ this.industryName }}
                                    <br />
                                    Sales Class: {{ this.vestimateReport.IF['sales-class'] }}
                                    <br />In addition to metrics from the traditional financial statement, the tables
                                    display values
                                    for full-time equivalent
                                    employees (for the calculation of Sales per Employee); full-time equivalent Average
                                    Annual
                                    Wage (for the calculation
                                    of the Efficiency Ratio, i.e., Sales per Employee/Average Annual Wage); and Owner
                                    Replacement Compensation and 1x Expense
                                    Addbacks for the accurate calculation of Owner Earnings.
                                  </p>
                                </div>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-size-100 p-0">
                                    <md-table v-model="VarianceFinancialAnalysis" table-header-color="blue"
                                      class="profit-and-loss-table">
                                      <md-table-row v-if="item.name" slot="md-table-row" slot-scope="{ item }">
                                        <md-table-cell :md-label="VarianceFinancialAnalysisAux[0].name"
                                          md-table="Parameters" class="md-table-side-label">{{ item.name }}
                                        </md-table-cell>
                                        <md-table-cell :hidden="checkName(item,'variance',key)"
                                          v-for="key in Object.keys(item.dates)" :md-label="key" :key="key">{{
                                          item.dates[key] }}</md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-tab>
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>
            <!-- <div class="extra_info_area neg_topMargin">
              <md-card>
                <md-card-header><md-icon>account_balance</md-icon>Curabitur Eleifend</md-card-header>
                <md-card-content>
                  <h4>Praesent venenatis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Quisque ut ex ligula</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card>
              <md-card>
                <md-card-header><md-icon>vertical_split</md-icon>Vivamus Hendrerit</md-card-header>
                <md-card-content>
                  <h4>Fusce feugiat mollis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Praesent eget sem eget</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scope>
 .market-industy .fundamentals_wpr .md-card-nav-tabs{
  width:100%;
  max-width:100% !important;
 }
</style>

<script>
import VRHeader from './_partials/VRHeader';
import { NavTabsCard } from "@/components";
import { mapState } from "vuex";

export default {
  components: {
    NavTabsCard,
    VRHeader,
  },

  props: ['headerData'],
  data() {
    return {
      showDialog: false,
      VarianceFinancialAnalysis: [],
      DollarsFinancialAnalysis: [],
      PercentagesFinancialAnalysis: [],
      VarianceFinancialAnalysisAux: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: state => state.user.vestimate_report.data,
      naics: state => state.user.vestimate_report.data.ptIMRnaics,
      industryName: state => state.user.vestimate_report.data.IMRindustry,
      displayArea: state => state.user.vestimate_report.data.MR.area,
      reportDate: state => state.user.vestimate_report.data.report_date,
      companyName: state => state.user.vestimate_report.data.input_structure['Company Name']['value']
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = "cash-flow-solvency";
    }

    this.switchView(section);
    let tableNames = [
      {
        name: "Income-Expense",
      },
      {
        name: "Revenue",
      },
      {
        name: "Officers Compensation",
      },
      {
        name: "Depreciation",
      },
      {
        name: "Operating Income",
      },
      {
        name: "Interest Expense",
      },
      {
        name: "Pre Tax Net Profit",
      },
      {
        name: "Owner Earnings",
      },
      {
        name: "Balance Sheet",
      },
      {
        name: "Accounts Receivable",
      },
      {
        name: "Total Current Assets",
      },
      {
        name: "Accounts Payable",
      },
      {
        name: "Current Liabilities",
      },
      {
        name: "Total Liabilities",
      },
      {
        name: "Net Worth",
      },
    ]
    let fullYears = this.vestimateReport.IF['ifDataYearsFull'];
    fullYears = fullYears.map(Number);
    tableNames.forEach((element, index) => {
      let c = {};
      c.id = index;
      c['name'] = element.name;
      c['dates'] = {};
      fullYears.forEach((el) => {
        if (this.vestimateReport.IF.data[el][element.name]) {
          if (this.vestimateReport.IF.data[el][element.name].variance) {
            c['dates'][el] = this.vestimateReport.IF.data[el][element.name].variance;
          } else {
            c['dates'][el] = "n/a";
          }
        } else {
          c['dates'][el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'variance');
        }
      })
      this.VarianceFinancialAnalysis.push(c);
    })
    this.VarianceFinancialAnalysisAux = [...this.VarianceFinancialAnalysis];
    this.VarianceFinancialAnalysis.shift();

    let f = {};
    f.name = "";
    f.industry = {};
    f.firm = {};
    tableNames.forEach((element, index) => {
      let k = {};
      k.id = index;
      k.industry = {};
      k.firm = {};
      k['name'] = element.name;

      fullYears.forEach((el) => {
        if (this.vestimateReport.IF.data[el][element.name]) {
          if (this.vestimateReport.IF.data[el][element.name].dollar) {
            k.industry[el] = this.vestimateReport.IF.data[el][element.name].dollar;
          } else {
            k.industry[el] = "n/a";
          }
          if (this.vestimateReport.IF.data[el][element.name].firm_dollar) {
            k.firm[el] = this.vestimateReport.IF.data[el][element.name].firm_dollar;
          } else {
            k.firm[el] = "n/a";
          }
        } else {
          k.industry[el] =  this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'industry');
          k.firm[el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'firm');
        }
        f.industry[el] = el;
        f.firm[el] = el;
      })
      this.DollarsFinancialAnalysis.push(k);
    })


    let x = {};
    x.name = "";
    x.industry = {};
    x.firm = {};
    tableNames.forEach((element, index) => {
      let j = {};
      j.id = index;
      j.industry = {};
      j.firm = {};
      j['name'] = element.name;
      fullYears.forEach((el) => {
        if (this.vestimateReport.IF.data[el][element.name]) {
          if (this.vestimateReport.IF.data[el][element.name].dollar) {
            j.industry[el] = this.vestimateReport.IF.data[el][element.name].percentage;
          } else {
            j.industry[el] = "n/a";
          }
          if (this.vestimateReport.IF.data[el][element.name].firm_dollar) {
            j.firm[el] = this.vestimateReport.IF.data[el][element.name].firm_percentage;
          } else {
            j.firm[el] = "n/a";
          }
        } else {
          j.industry[el] =  this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'industry');
          j.firm[el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'firm');
        }
        x.industry[el] = el;
        x.firm[el] = el;
      })
      this.PercentagesFinancialAnalysis.push(j);
    })


  },
  watch: {
    "$route.query.section"() {
      let section = this.$route.query.section;

      if (!section) {
        section = "cash-flow-solvency";
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    checkName: function (item, type,key){
      if (item.name === 'Balance Sheet')
        return true;

      return false;
    },
     customElement: function (name, year, element, type) {
      if (name === "Income-Expense")
        return year;
    }
  },
};
</script>
<style lang="scss">
.ratios-report {
  .financal-report-col-1 {
    display: flex;
    align-items: center;

    h4 {
      margin-top: 0;
    }
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .finanical-report-messages {
    display: flex;
    justify-content: space-between;
  }

  .messages-box {
    border-radius: 3px;
    background-color: #cccccc;
    padding: 1px !important;
    margin: 10px 30px;

    .md-ripple {
      display: flex;
      align-items: center;

      .md-icon {
        font-size: 1.1rem !important;
        color: #78909c;
      }
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}

.md-dialog {
  .md-dialog-container {
    max-width: 920px;
    padding: 45px;
    position: relative;
    left: 66px;
  }
}
</style>
